import { createContext } from 'react';

export interface IColorModeContext {
    toggleColorMode: () => void;
    mode: 'light' | 'dark';
    buttonVariant: 'contained' | 'outlined';
}
export const ColorModeContext = createContext<IColorModeContext | null>(null);